import { render, staticRenderFns } from "./collection-report.pug?vue&type=template&id=5378a8be&scoped=true&lang=pug&"
import script from "./collection-report.ts?vue&type=script&lang=ts&"
export * from "./collection-report.ts?vue&type=script&lang=ts&"
import style0 from "./collection-report.styl?vue&type=style&index=0&id=5378a8be&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5378a8be",
  null
  
)

export default component.exports